import React from "react";
import ReactDOM from "react-dom/client";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ProductSharePage from "./pages/ProductSharePage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />, // 홈 페이지
    errorElement: <p>Error</p>, // 404 페이지
  },
  {
    path: "/product/share/:name",
    element: <ProductSharePage />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

reportWebVitals();
